// tslint:disable:max-line-length
import {
    Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input, Output,
    OnInit, Directive, ContentChild, forwardRef, QueryList, EventEmitter, HostListener } from '@angular/core';
import { BaseDirective } from '../../../../base.directive';
import { UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-page-column',
    templateUrl: './eui-page-column.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiPageColumnComponent extends BaseDirective implements OnInit {

    @Input() size;
    @Input() label;
    @Input() isCollapsible = false;
    @Input() isCollapsed = false;
    @Input() isHighlighted = false;
    @Input() interactiveScrollbars = true;
    @Input() isCollapsedWithIcons = false;      // contains ux-layout-sidebar-items
    @Input() hasSidebarMenu = false;            // contains eui-sidebar-menu
    @Input() hasHeaderBodyShrinkable = false;   // allow to track scroll event Up & Down

    @Output() collapsed = new EventEmitter();
    @Output() headerCollapsed = new EventEmitter();

    isActive = false;
    isHeaderBodyShrinked = false;

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses('eui-page-column'),
            this.size && !this.isCollapsed ? `eui-page-column--size-${this.size}` : ``,
            this.isCollapsed ? 'eui-page-column--collapsed' : '',
            this.isCollapsedWithIcons ? 'eui-page-column__header--with-icons' : '',
            this.isHighlighted ? 'eui-page-column--highlighted' : '',
            this.isActive ? 'eui-page-column--active' : '',
            this.interactiveScrollbars ? 'eui-page-column--interactive-scrollbars' : '',
            this.hasSidebarMenu ? 'eui-page-column--has-sidebar-menu' : '',
            this.isHeaderBodyShrinked ? 'eui-page-column__header--shrinked' : '',
        ].join(' ').trim();
    }

    @ContentChild(forwardRef(() =>
        EuiPageColumnHeaderBodyContentDirective),
    ) customHeaderBodyContent: QueryList<EuiPageColumnHeaderBodyContentDirective>;

    @ContentChild(forwardRef(() =>
        EuiPageColumnHeaderLeftContentDirective),
    ) customHeaderLeftContent: QueryList<EuiPageColumnHeaderLeftContentDirective>;

    @ContentChild(forwardRef(() =>
        EuiPageColumnHeaderRightContentDirective),
    ) customHeaderRightContent: QueryList<EuiPageColumnHeaderRightContentDirective>;

    @ContentChild(forwardRef(() =>
        EuiPageColumnHeaderCollapsedContentDirective),
    ) customHeaderCollapsedContent: QueryList<EuiPageColumnHeaderCollapsedContentDirective>;

    @ContentChild(forwardRef(() =>
        EuiPageColumnFooterContentDirective),
    ) customFooterContent: QueryList<EuiPageColumnFooterContentDirective>;

    currentOffset = 0;
    previousOffset = 0;
    treshHold = 50;

    constructor( public asService: UxAppShellService ) {
        super();
    }

    @HostListener('window:scroll', ['$event'])
    onBodyScoll(event) {
        if (this.hasHeaderBodyShrinkable && event.target) {
            this.currentOffset = event.target.scrollTop;
            // Scroll DOWN
            if (this.currentOffset > this.previousOffset && this.currentOffset > this.treshHold) {
                // console.log('Scroll DOWN:', this.currentOffset);
                this.isHeaderBodyShrinked = true;
                this.headerCollapsed.emit(true);
            }
            // Scroll UP
            if (this.currentOffset <= this.previousOffset) {
                // console.log('Scroll UP:', this.currentOffset);
                if (this.currentOffset <= this.treshHold) {
                    this.isHeaderBodyShrinked = false;
                    this.headerCollapsed.emit(false);
                }
            }
            this.previousOffset = this.currentOffset;
        }
    }

    ngOnInit() {
        this.euiSizeS = false; // Bypass size default
    }

    public onToggle() {
        this.isCollapsed = !this.isCollapsed;
        this.collapsed.emit(this.isCollapsed);
    }

    public onMouseEnter() {
        if (this.interactiveScrollbars) {
            this.isActive = true;
        }
    }

    public onMouseLeave() {
        if (this.interactiveScrollbars) {
            this.isActive = false;
        }
    }
}

/* tslint:disable */
@Directive({ selector: 'eui-page-column-header-body' })
export class EuiPageColumnHeaderBodyContentDirective { }
@Directive({ selector: 'eui-page-column-header-left-content' })
export class EuiPageColumnHeaderLeftContentDirective { }
@Directive({ selector: 'eui-page-column-header-right-content' })
export class EuiPageColumnHeaderRightContentDirective { }
@Directive({ selector: 'eui-page-column-header-collapsed-content' })
export class EuiPageColumnHeaderCollapsedContentDirective { }
@Directive({ selector: 'eui-page-column-body' })
export class EuiPageColumnBodyContentDirective { }
@Directive({ selector: 'eui-page-column-footer' })
export class EuiPageColumnFooterContentDirective { }
/* tslint:enable */
